import * as Sentry from "@sentry/react";
import { RefreshCw, TriangleAlert } from "lucide-react";
import { useEffect } from "react";
import { useRouteError } from "react-router-dom";

import { ColocaButton } from "@/shared/components/buttons/ColocaButton";
import { ColocaEmpty } from "@/shared/components/feedback/ColocaEmpty";
import useTranslations from "@/shared/lang/useTranslations";

/**
 * Router-level `errorElement`. Any render error under the route tree lands here instead of on React Router's
 * built-in "Unexpected Application Error!" screen, which dumps the raw stack and offers no way out. Reloading
 * recovers, so that is the single action offered.
 */
export function RouteErrorScreen() {
  const { t } = useTranslations("global");
  const error = useRouteError();

  // React Router's error boundary stops the throw from ever reaching window.onerror,
  // so without this the crash would be invisible to Sentry.
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-6">
      <ColocaEmpty
        icon={TriangleAlert}
        title={t("route_error_title")}
        description={t("route_error_description")}
        className="max-w-md border-none bg-transparent"
      >
        <ColocaButton variant="primary" icon={RefreshCw} onClick={() => window.location.reload()}>
          {t("route_error_reload")}
        </ColocaButton>
      </ColocaEmpty>
    </div>
  );
}
